const TaskManagementRoute = ({children}) => {
  return children
}

export default TaskManagementRoute